

import { EnumDescription } from "../decorator/enum-description.decorator";

export class EnumSimNao {

  @EnumDescription("Ativo")
  static Sim = true;

  @EnumDescription("Inativo")
  static Nao = false;

  // Adicionar uma propriedade auxiliar para registrar descrições
  static _descriptions: Record<string, string>;
}
